import React from 'react'
import { Divider, Modal } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import ButtonPurple from 'components/design/Form/ButtonPurple'
import classNames from 'classnames'

import LinkPurple from 'components/design/Form/LinkPurple'
import style from './style.module.scss'

const UpgradeToUnlockFeature = () => {
  const settings = useSelector(state => state.settings)
  const apps = useSelector(state => state.apps)
  const dispatch = useDispatch()
  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const { visibleModalID } = settings
  const modalID = 'upgradeToUnlockFeatureModal'
  const visible = modalID === visibleModalID
  return (
    <Modal
      className="custom__form__modal"
      open={visible}
      title={false}
      footer={false}
      onCancel={handleCancel}
      afterClose={handleCancel}
      maskClosable={false}
      closable
    >
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div className={classNames(style.deletedAppContainer)}>
            <div className={style.headerMain}>
              <h4>Analytics & Insights</h4>
            </div>
            <Divider style={{ margin: '20px -24px', width: '110%' }} />
            <div className={style.bodyMain}>
              <p className={style.body}>
                Insights are not included in your current plan. The following is a demonstration of
                the Insights Feature. <br /> <br /> Please upgrade your plan to activate Insights
                for your app.
              </p>
            </div>
            <Divider style={{ margin: '20px -24px', width: '110%' }} />
            <div
              className={style.footerMain}
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                columnGap: '16px',
              }}
            >
              <ButtonPurple
                buttonText="Preview"
                onClick={handleCancel}
                holderStyles={{ width: 'fit-content' }}
              />
              <LinkPurple
                onClick={() => {
                  const anchorElement = document.createElement('a')
                  anchorElement.href = 'https://www.cometchat.com/contact-sales'
                  anchorElement.target = '_blank'
                  anchorElement.rel = 'noopener noreferrer'
                  anchorElement.click()
                }}
                linktext={<> Contact Sales</>}
                classes={style.logInLink}
                to={`/app/${apps.active.id}/analytics`}
                linkHolderStyles={{ display: 'inline-flex' }}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default UpgradeToUnlockFeature
